<template>
  <div>
    <base-material-card
      class="cameraItem px-5 py-3"
      color="primary"
      :title="item.camera.camera_name"
      @click.native="enterCamera(item)"
    >
      <v-row class="cameraItem">
        <v-col>
          <GuardianSnapshot
            :image="snapshot.data"
            :fences="item.fences"
            :height="300"
            :width="500"
          ></GuardianSnapshot>
        </v-col>
      </v-row>
    </base-material-card>
  </div>
</template>

<script>
import GuardianSnapshot from "@/components/guardian/GuardianSnapshot";
import { getSnapshot } from "@/endpoint/camera";

export default {
  name: "cameraItem",
  components: { GuardianSnapshot },
  props: ["type", "item"],
  data() {
    return {
      snapshot: {
        data: "",
      },
    };
  },
  created() {
    this.init(this);
  },
  methods: {
    async init(scope) {
      scope.snapshot = await getSnapshot(this.item.camera.camera_id);
    },
    enterCamera(camera) {
      if (this.type == "licensePlate") {
        this.$router.push({
          name: "licensePlate",
          params: { uuid: camera._id },
        });
      }
    },
    random() {
      let random = Math.random(0, 100);
      return random;
    },
  },
};
</script>

<style>
.cameraItem {
  cursor: pointer;
}
</style>